/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.key";

export { $nsid };

/** Record linking an atproto identity with a stream signing key */
type Main = { $type: "place.stream.key";

  /**
   * The did:key signing key for the stream.
   */
  "signingKey":string;

  /**
   * Client-declared timestamp when this key was created.
   */
  "createdAt":l.DatetimeString;

  /**
   * The name of the client that created this key.
   */
  "createdBy"?:string };

export type { Main };

/** Record linking an atproto identity with a stream signing key */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"signingKey":/*#__PURE__*/ l.string({"maxLength":57,"minLength":57}),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"createdBy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
